export default __webpack_public_path__ + "static/svatby_poster_sm-805bd14642d541c99d8b4eb2223b56b0.webp";